
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22.224 6c2.137.357 4.219.992 6.189 1.884 3.395 4.913 5.082 10.454 4.46 16.847a24.914 24.914 0 01-7.596 3.769 17.926 17.926 0 01-1.626-2.592c.89-.33 1.749-.733 2.565-1.212a8.892 8.892 0 01-.628-.467 18.001 18.001 0 01-15.177 0c-.202.154-.412.313-.627.467.816.477 1.673.883 2.56 1.21a18.16 18.16 0 01-1.626 2.594 25.028 25.028 0 01-7.59-3.771c-.532-5.513.53-11.105 4.447-16.84A25.281 25.281 0 0113.77 6c.293.518.557 1.05.793 1.595a23.352 23.352 0 016.869 0c.236-.544.5-1.077.793-1.595zm-11.91 12.375c0 1.635 1.223 2.964 2.703 2.964 1.507 0 2.673-1.329 2.699-2.963.026-1.635-1.187-2.975-2.704-2.975-1.517 0-2.697 1.34-2.697 2.974zm9.97 0c0 1.635 1.218 2.964 2.7 2.964 1.507 0 2.67-1.329 2.696-2.963.026-1.635-1.177-2.975-2.697-2.975s-2.699 1.34-2.699 2.974z","fill":"#fff"}})])
          )
        }
      }
    